import api from '@/api/axios'

export default {
  getCaptcha: (data, config) => api.post('/send_captcha', data, config),
  register: (data, config) => api.post('/user', data, config),
  login: (data, config) => api.post('/login', data, config),
  getInfo: config => api.get('/user', config),
  logout: config => api.post('/user/logout', null, config),
  resetPassword: (data, config) => api.post('/reset_password', data, config)
}
